import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useState } from 'react';
import buttonStyles from '../styles/Button.module.css';
import Icon from './Icon';

// Not yet in TypeScript's DOM types
interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
}

// Offers to install the site as an app, on browsers that support it (e.g.
// Chrome and Edge). Hidden elsewhere and once installed.
const InstallButton = () => {
  const [installPrompt, setInstallPrompt] = useState<BeforeInstallPromptEvent | null>(null);

  useEffect(() => {
    const onBeforeInstallPrompt = (e: Event) => {
      e.preventDefault();
      setInstallPrompt(e as BeforeInstallPromptEvent);
    };
    const onInstalled = () => setInstallPrompt(null);
    window.addEventListener('beforeinstallprompt', onBeforeInstallPrompt);
    window.addEventListener('appinstalled', onInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onBeforeInstallPrompt);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  if (!installPrompt) return null;

  return (
    <button
      className={`${buttonStyles.button} ${buttonStyles.iconButton}`}
      onClick={async () => {
        await installPrompt.prompt();
        // The prompt can only be shown once
        setInstallPrompt(null);
      }}
    >
      <Icon icon={faDownload} />
      Install web app
    </button>
  );
};

export default InstallButton;
